<template lang="pug">
v-card
  v-card-title 
    span
      span Failed send
      
  v-divider
  v-card-text
    h2.text-center.red--text.mt-2 Succes sent to {{ successSendCount }}/{{ totalSendCount}}
    h3.text-center.mt-2 {{ error }}
    v-data-table(
      :headers="headers"
      :items="list"
      item-key="ID"
      :server-items-length="list.length"
      hide-default-footer
      :mobile-breakpoint='NaN'
      class="app-table mt-4 elevation-1"
    )
      template(v-slot:item="{item, index}")
        tr 
          td {{ item.number }}
          td {{ item.dob }}
          td {{ item.name }}
          td {{ item.email }}
          td {{ item.phone }}
  v-card-actions
    span
    v-spacer
    v-btn(
      @click="$emit('input', false)"
      outlined
    ).btn-common Ok
          
  
  v-card-actions
</template>

<script>
export default {
  props: {
    list: Array,
    error: String,
    totalSendCount: Number
  },

  data: () => ({
    headers: [
      { text: 'CDN', value: 'candidate_number', align: 'left', class: 'nowrap cell-placed-paid', sortable: false },
      { text: 'Date of Birth', value: 'dOB', align: 'left', class: 'nowrap cell-placed-paid', sortable: false },
      { text: 'Name', value: 'candidateName', align: 'left', class: 'cell-name', sortable: false },
      { text: 'Email', value: 'candidateEmail', class: 'nowrap cell-bday', sortable: false },
      { text: 'Phone Number', value: 'edit', class: 'app-table__h_small cell-btns', sortable: false },
    ],
  }),

  computed: {
    successSendCount() {
      return this.totalSendCount - this.list.length
    }
  }
}
</script>